/**
 * StaffPortalPolicyAssignmentService
 * Service for staff policy-assignment operations.
 * Route: api/staff-portal/policy-assignments
 */
import { StaffPortalBaseService } from './StaffPortalBaseService';
export class StaffPortalPolicyAssignmentService extends StaffPortalBaseService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? StaffPortalPolicyAssignmentService.DEFAULT_SERVICE_PATH,
            basePath: config?.basePath ?? StaffPortalPolicyAssignmentService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    /**
     * List policy assignments for the current staff member.
     * Optional status filter: Pending | Signed | Overdue | Waived | Superseded.
     * GET /api/staff-portal/policy-assignments?status=Pending
     */
    async getMyAssignments(status) {
        const response = await this.getMyAssignmentsRaw(status);
        return response.data ?? [];
    }
    getMyAssignmentsRaw(status) {
        const url = this.buildUrlWithParams(undefined, { status });
        return this.http.get(url);
    }
    /**
     * Get a specific policy assignment.
     * GET /api/staff-portal/policy-assignments/{id}
     */
    async getAssignment(id) {
        const response = await this.getAssignmentRaw(id);
        if (!response.data) {
            throw new Error(`Policy assignment ${id} not found`);
        }
        return response.data;
    }
    getAssignmentRaw(id) {
        return this.get(String(id));
    }
    /**
     * Sign a policy assignment as the current staff member.
     * POST /api/staff-portal/policy-assignments/{id}/sign
     */
    async signAssignment(id, request) {
        const response = await this.signAssignmentRaw(id, request);
        if (!response.data) {
            throw new Error('Failed to sign policy assignment');
        }
        return response.data;
    }
    signAssignmentRaw(id, request) {
        return this.post(`${id}/sign`, request ?? {});
    }
}
// Routes through the HRManagement API gateway — see StaffPortalDutyService.
StaffPortalPolicyAssignmentService.DEFAULT_SERVICE_PATH = 'hr';
StaffPortalPolicyAssignmentService.BASE_PATH = 'api/staff-portal/policy-assignments';
//# sourceMappingURL=StaffPortalPolicyAssignmentService.js.map